(function () {
  'use strict';

  var root;
  var input;
  var grid;
  var status;
  var timer;
  var requestId = 0;

  function icon() {
    return '<svg viewBox="0 0 32 32" aria-hidden="true"><circle cx="14" cy="14" r="8.5"></circle><path d="m20.5 20.5 7 7"></path></svg>';
  }

  function money(amount) {
    var value = Number(amount || 0);
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(value);
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (character) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;' })[character];
    });
  }

  function card(product) {
    var image = product.featured_image && product.featured_image.url;
    var alt = product.featured_image && product.featured_image.alt || product.title;
    return '<article class="jjt-search-card">' +
      '<a class="jjt-search-card__image" href="' + escapeHtml(product.url) + '">' +
      (image ? '<img src="' + escapeHtml(image) + '&width=700" alt="' + escapeHtml(alt) + '" loading="lazy">' : '') +
      '</a><div class="jjt-search-card__copy">' +
      '<a href="' + escapeHtml(product.url) + '">' + escapeHtml(product.title) + '</a>' +
      '<span>' + money(product.price) + '</span></div></article>';
  }

  function render(products, query) {
    status.textContent = query ? products.length + ' products' : '';
    if (!products.length) {
      grid.innerHTML = '<p class="jjt-search-system__empty">No products found.</p>';
      return;
    }
    grid.innerHTML = products.map(card).join('');
  }

  function search(query) {
    var normalized = String(query || '').trim();
    var id = ++requestId;
    status.textContent = normalized ? 'Searching…' : '';
    fetch('/search/suggest.json?q=' + encodeURIComponent(normalized || 'core') + '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (response) { return response.json(); })
      .then(function (data) {
        if (id !== requestId) return;
        var products = data && data.resources && data.resources.results && data.resources.results.products || [];
        render(products, normalized);
      })
      .catch(function () {
        if (id !== requestId) return;
        status.textContent = '';
        grid.innerHTML = '<p class="jjt-search-system__empty">Search is temporarily unavailable.</p>';
      });
  }

  function close() {
    if (!root) return;
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('jjt-search-open');
  }

  function open() {
    build();
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.body.classList.add('jjt-search-open');
    window.setTimeout(function () { input.focus(); }, 40);
    if (!grid.children.length) search('');
  }

  function build() {
    if (root) return;
    root = document.createElement('section');
    root.className = 'jjt-search-system';
    root.setAttribute('aria-hidden', 'true');
    root.innerHTML =
      '<button class="jjt-search-system__shade" type="button" aria-label="Close search"></button>' +
      '<aside class="jjt-search-system__panel" role="dialog" aria-modal="true" aria-label="Search">' +
      '<button class="jjt-search-system__close" type="button" aria-label="Close search">×</button>' +
      '<form class="jjt-search-system__form" action="/search" method="get">' + icon() +
      '<input class="jjt-search-system__input" type="search" name="q" autocomplete="off" placeholder="Search for products and FAQs" aria-label="Search">' +
      '<button class="jjt-search-system__clear" type="button" aria-label="Clear search">×</button></form>' +
      '<h2 class="jjt-search-system__suggestions-title">Suggested searches</h2>' +
      '<div class="jjt-search-system__suggestions"><button type="button">Core Gi</button><button type="button">Rashguards</button><button type="button">No-Gi Shorts</button><button type="button">Belts</button><button type="button">Workout Shorts</button></div>' +
      '<h2>Products</h2><p class="jjt-search-system__status" aria-live="polite"></p><div class="jjt-search-system__grid"></div>' +
      '</aside>';
    document.body.appendChild(root);
    input = root.querySelector('.jjt-search-system__input');
    grid = root.querySelector('.jjt-search-system__grid');
    status = root.querySelector('.jjt-search-system__status');

    root.querySelector('.jjt-search-system__shade').addEventListener('click', close);
    root.querySelector('.jjt-search-system__close').addEventListener('click', close);
    root.querySelector('.jjt-search-system__clear').addEventListener('click', function () {
      input.value = '';
      input.focus();
      search('');
    });
    root.querySelectorAll('.jjt-search-system__suggestions button').forEach(function (button) {
      button.addEventListener('click', function () {
        input.value = button.textContent;
        search(button.textContent);
      });
    });
    input.addEventListener('input', function () {
      window.clearTimeout(timer);
      timer = window.setTimeout(function () { search(input.value); }, 180);
    });
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('a[href="/search"],a[href^="/search?"],.js-search-header,[data-jjt-on-search]');
    if (!trigger || (root && root.contains(trigger))) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    open();
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') close();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', build);
  } else {
    build();
  }
})();
